import isNumberInRange from 'utils/isNumberInRange';

// We are mutating here because this method is used in an action wrapped by
// immer.
function updateLibraryAcademyTopicOrder({
  library,
  libraryAcademyTopicId,
  newOrder,
}) {
  const libraryAcademyTopic = library.library_academy_topics.find(
    (o) => o.id === libraryAcademyTopicId
  );
  const currentOrder = libraryAcademyTopic.order;
  // If moving down i.e newOrder > currentOrder then all library academy topics
  // between the new and old order should be moved up by decreasing order
  // by 1.
  // If moving up i.e newOrder < currentOrder then all library academy topics
  // between the new and old order should be moved down by increasing order
  // by 1.
  const moveEffectRowsOrderBy = newOrder > currentOrder ? -1 : 1;
  library.library_academy_topics.forEach((item) => {
    let order = item.order;
    if (item.id === libraryAcademyTopicId) {
      order = newOrder;
    } else if (isNumberInRange([currentOrder, newOrder], order)) {
      order += moveEffectRowsOrderBy;
    }

    item.order = order;
  });
}

export default updateLibraryAcademyTopicOrder;
